<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_research_intro')
}

const isOnResearchSection = computed(() => {
  return route.path.startsWith('/research')
})

const goToResearch = () => {
  router.push('/research')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/science.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.research.intro.hello') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.research.intro.throughResearch') }}
      </p>
      <p class="pb-2">
        <i18n-t keypath="tutorial.research.intro.requiresScience" tag="span">
          <template #icon><GenericIcon type="science" /></template>
        </i18n-t>
      </p>
      <p class="pb-2">
        {{ t('tutorial.research.intro.opensPossibilities') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info" class="hidden md:flex">
        {{ t('tutorial.research.intro.clickResearchDesktop') }}
      </AlertBox>
      <AlertBox type="info" class="md:hidden">
        {{ t('tutorial.research.intro.clickResearchMobile') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnResearchSection" @click="goToResearch" class="mr-2">
        {{ t('tutorial.research.intro.gotoResearch') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.research.intro.imThere') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>